import eventShowcaseUrls from './event-showcase.urls';
import networkService from '../network-service/network.service';
import { getData } from '@project/services/utils';

const getShowcaseCategories = async () => {
  const url = eventShowcaseUrls.getShowcaseCategoriesUrl();

  return networkService.get(url).then(getData);
};

const getShowcaseCategory = async (id: string) => {
  const url = eventShowcaseUrls.getShowcaseCategoryUrl(id);

  return networkService.get(url).then(getData);
};

const getShowcase = async (id: string) => {
  const url = eventShowcaseUrls.getShowcaseUrl(id);

  return networkService.get(url).then(getData);
};

export default {
  getShowcaseCategories,
  getShowcaseCategory,
  getShowcase,
};
